import React, { Fragment } from 'react';
import dev from 'src/lib/logger';
import dynamic from 'next/dynamic';
import { FRESH_THEME, RUSTY_THEME } from 'src/lib/constants/general';
import { useSelector } from 'react-redux';
import { getIsLoadingProducts, getIsLoadedProductsFail, getIsNoResults, getIsLoadingMoreProducts } from 'src/lib/redux/modules/search';
import { getCurrentTheme, getIsComplaintMode } from 'src/lib/redux/modules/settings';

// SEARCH PAGES
const FreshSearchPage = dynamic(
	() => import(/* webpackMode: "lazy" */ /* webpackChunkName: "fresh-search" */ 'src/themes/fresh/pages/search/search'),
	{ ssr: false }
);
const RustySearchPage = dynamic(
	() => import(/* webpackMode: "lazy" */ /* webpackChunkName: "rusty-search" */ 'src/themes/rusty/pages/search/search'),
	{ ssr: false }
);
// LOADING
const LoadingOverlay = dynamic(() =>
	import(/* webpackMode: "lazy" */ /* webpackChunkName: "loading-overlay" */ 'src/components/LoadingOverlay/LoadingOverlay')
);

// NO RESULTS PAGE
const NoResults = dynamic(
	() => import(/* webpackMode: "lazy" */ /* webpackChunkName: "no-results" */ 'src/components/NoResults/NoResults'),
	{ ssr: false }
);

// const Outbrain = dynamic(() => import(/* webpackMode: "lazy" */ /* webpackChunkName: "out" */ 'src/components/Outbrain/Outbrain'), {
// 	ssr: false,
// });

const Feed = () => {
	const isLoadingProducts = useSelector(state => getIsLoadingProducts(state.search));
	const isLoadingMoreProducts = useSelector(state => getIsLoadingMoreProducts(state.search));
	const isLoadedProductsFail = useSelector(state => getIsLoadedProductsFail(state.search));
	const isNoResults = useSelector(state => getIsNoResults(state.search));
	const currentTheme = useSelector(state => getCurrentTheme(state.settings));
	const isComplaint = useSelector(state => getIsComplaintMode(state.settings));
	const getPage = () => {
		let SearchPage = null;
		switch (currentTheme) {
			case FRESH_THEME:
				dev('search theme fresh');
				SearchPage = <FreshSearchPage />;
				break;
			case RUSTY_THEME:
				dev('search theme rusty');
				SearchPage = <RustySearchPage />;
				break;
			default:
				dev('search theme rusty');
				SearchPage = <RustySearchPage />;
				console.warn('Search: Fallback to rusty , got ', currentTheme);
				break;
		}

		return SearchPage;
	};

	if (isLoadingProducts || (isLoadingMoreProducts && isComplaint)) {
		// Loading
		return <LoadingOverlay />;
	}

	if (!isLoadingProducts && (isLoadedProductsFail || isNoResults)) {
		// No ProductAds
		return (
			<Fragment>
				<NoResults />
				{/* <Outbrain /> */}
			</Fragment>
		);
	}

	return getPage();
};

Feed.propTypes = {};

Feed.defaultProps = {};

export default Feed;
